// src/auth/logout.js
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'

export function performLogoutWithoutRedirect(store) {
  // Remove JWT tokens
  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
  localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

  // Remove app-specific localStorage items
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem("memberDts")
  localStorage.removeItem("quote_info")
  localStorage.removeItem("quote_info_app")
  localStorage.removeItem("checkedProducts")
  localStorage.removeItem("adminPanel")

  // Clear sessionStorage
  sessionStorage.clear()

  // Remove cookies
  try {
    window.$cookies.remove('jwt')
    window.$cookies.remove('jwt', '/')
    window.$cookies.remove('jwt', '/', window.location.hostname)
    window.$cookies.remove('jwt', '/', '.' + window.location.hostname)
  } catch (e) {}

  // Reset abilities
  store.$ability?.update(initialAbility)

  // Clear Vuex user data
  store.commit('app/USER_DATA', null)

  window.location.href = '/login'
}